import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import styles from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      iconeRestricao: {
        margin: theme.spacing(1)
      },
      infoCardPresentesActived: {
        color: styles.primarySicredi,
        cursor: 'pointer',
      },
      loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        width: '100%',
        height: '100vh',
        padding: theme.spacing(),
        boxSizing: 'border-box'
      },
      content: {
        margin: theme.spacing(4, 0),
      },
      topContent: {
        maxHeight: 640,
      },
      topContentWithPlayer: {
        display: 'flex',
        flexDirection: 'column',
      },
      info: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        marginBottom: theme.spacing(2),
        '& > *': {
          marginBottom: theme.spacing(2),
        },
        '& h1': {
          width: '100%',
        },
        '$miniPlayer ~ &': {
          [theme.breakpoints.up('lg')]: {
            marginTop: 250,
          }
        }
      },
      loading: {
        alignSelf: 'center'
      },
      spaceTop: {
        marginTop: 10,
      },
      spaceBotton: {
        marginBottom: 40
      },
      infoCard: {
        marginTop: 17,
        width: 320,
        boxShadow: '0px 5px 10px rgba(0, 0, 0, 0.1) !important'
      },
      containerInfoCard: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
      },
      chat: {
        height: 301
      }
    }),
  { name: 'AssembleiaAssociado' }
);
